export default {
  root: {
    flex: 1,
    alignItems: 'flex-end',
    padding: '0 !important',
  },
};
